// faq
$(function () {
  // すべての回答を一旦非表示
  $('.c-faq__a-warp').hide();
  // is-openが付いているものだけ即時表示
  $('.c-faq.is-open .c-faq__a-warp').slideDown(0);

  $('.c-faq__q').on('click', function () {
    var $faq = $(this).closest('.c-faq');
    $faq.toggleClass('is-open');
    $faq.find('.c-faq__a-warp').stop(true, true).slideToggle(200);
  });
});

// 商品トグル
$(function () {
  var mediaQuery = window.matchMedia('(max-width: 768px)');

  function setProductBlockInitialState() {
    if (mediaQuery.matches) {
      // SP時：すべて閉じる
      $('.p-product-item__block').removeClass('is-open');
      $('.p-product-item__block-content').hide();
    } else {
      // PC時：is-openが付いているものだけ開く
      $('.p-product-item__block-content').hide();
      $('.p-product-item__block.is-open .p-product-item__block-content').show();
    }
  }

  // 初期表示
  setProductBlockInitialState();

  // リサイズ時も状態を調整
  mediaQuery.addEventListener('change', setProductBlockInitialState);

  $('.p-product-item__block-title').on('click', function () {
    var $block = $(this).closest('.p-product-item__block');
    var $content = $block.find('.p-product-item__block-content');

    $block.toggleClass('is-open');
    $content.stop(true, true).slideToggle(200);
  });
});

// レスポンシブ時ギャラリー
$(function () {
  $('.p-product-item__gallery-btn-wrap').click(function () {
    $(this).toggleClass('is-open');
    $('.p-product-item__side').toggleClass('is-open');
    $('body').toggleClass('modal-open');
  });
  $('.p-product-item__back').click(function () {
    $('.p-product-item__gallery-btn-wrap').removeClass('is-open');
    $('.p-product-item__side').removeClass('is-open');
    $('body').toggleClass('modal-open');
  });
});

// レスポンシブギャラリー内のモーダル画像表示
// $(function () {
//   $('.p-product-item__thumb img').on('click', function () {
//     var imgSrc = $(this).attr('src');
//     $('#product-image-modal-img').attr('src', imgSrc);
//     $('#product-image-modal').css('display', 'flex');
//   });
//   $('#product-image-modal').on('click', function () {
//     $(this).css('display', 'none');
//     $('#product-image-modal-img').attr('src', '');
//   });
// });

// レスポンシブギャラリー内のスライダー
$(function () {
  let modalSlider = null;
  let allImages = [];

  // 画像データを取得
  function initializeImageData() {
    allImages = [];
    $('.p-product-item__thumb img').each(function () {
      allImages.push({
        src: $(this).attr('src'),
        alt: $(this).attr('alt')
      });
    });
  }

  // モーダルを開く
  function openModal(clickedIndex = 0) {
    const $modalSlider = $('.modal-slick-slider');

    // 既存のスライダーを破棄
    if (modalSlider) {
      $modalSlider.slick('destroy');
      modalSlider = null;
    }

    // スライダーコンテンツをクリア
    $modalSlider.empty();

    // 画像を追加
    allImages.forEach((image, index) => {
      const slideHtml = `
        <div class="modal-slide">
          <img src="${image.src}" alt="${image.alt}" style="width: 100%; height: 80vh; object-fit: contain;">
        </div>
      `;
      $modalSlider.append(slideHtml);
    });

    // Slickスライダーを初期化
    modalSlider = $modalSlider.slick({
      initialSlide: clickedIndex,
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      centerMode: true,
      centerPadding: '0px',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerPadding: '0px',
          }
        }
      ]
    });

    // モーダルを表示
    $('#product-image-modal').fadeIn(300);
  }

  // モーダルを閉じる
  function closeModal() {
    $('#product-image-modal').fadeOut(300, function () {
      if (modalSlider) {
        $('.modal-slick-slider').slick('destroy');
        modalSlider = null;
      }
    });
  }

  // サムネイルクリック時
  $('.p-product-item__thumb img').on('click', function () {
    initializeImageData();

    const clickedSrc = $(this).attr('src');
    const clickedIndex = allImages.findIndex(img => img.src === clickedSrc);

    openModal(clickedIndex >= 0 ? clickedIndex : 0);
  });

  // モーダル操作
  $(document).on('click', '.modal-close-btn', function (e) {
    e.stopPropagation();
    closeModal();
  });

  $(document).on('click', '#product-image-modal', function (e) {
    if (e.target === this) {
      closeModal();
    }
  });

  // キーボード操作
  $(document).on('keydown', function (e) {
    if ($('#product-image-modal').is(':visible')) {
      switch (e.key) {
        case 'Escape':
          closeModal();
          break;
        case 'ArrowLeft':
          if (modalSlider) {
            $('.modal-slick-slider').slick('slickPrev');
          }
          break;
        case 'ArrowRight':
          if (modalSlider) {
            $('.modal-slick-slider').slick('slickNext');
          }
          break;
      }
    }
  });

  // スワイプ対応はSlickが自動で処理
});

// サイズリンクのガイドボタン　トグル
$(function () {
  $('#size_guide').on('click', function () {
    var $sizeAnchor = $('#size-anchor');
    var $content = $sizeAnchor.find('.p-product-item__block-content');
    if (!$sizeAnchor.hasClass('is-open')) {
      $sizeAnchor.addClass('is-open');
      $content.stop(true, true).slideDown(200);
    }
  });
});

$(function () {
  $('#size_guide_2').on('click', function () {
    var $sizeAnchor = $('#size-anchor_2');
    var $content = $sizeAnchor.find('.p-product-item__block-content');
    if (!$sizeAnchor.hasClass('is-open')) {
      $sizeAnchor.addClass('is-open');
      $content.stop(true, true).slideDown(200);
    }
  });
});


